import React from 'react';
import { getIn, useFormikContext } from 'formik';

import CheckboxFormik from '~/components/CheckboxFormik';
import MonetaryValueTextFieldFormik from '~/components/core/Formik/MonetaryValueTextFieldFormik';
import PermissionsButtonWrapper from '~/components/core/Permissions/PermissionsButtonWrapper';
import { PERMISSION_ACTIONS, PERMISSION_VERBS } from '~/components/core/Permissions/PermissionUtils';
import Text from '~/components/core/TextComponents/Text';
import { usePaymentsConfiguration } from '~/components/hooks/usePaymentsConfiguration';
import { DatePickerTextFieldFormik } from '~/components/TextFieldFormik';

import { FORMIK_FINANCE_FIELD_IDS } from './constants';
import { getFullFinancePath } from './utils';

interface TrustedPayeeProps {
  disabled?: boolean;
}

const TrustedPayee: React.FC<TrustedPayeeProps> = ({ disabled }) => {
  const { values } = useFormikContext();
  const { isTrustedPayeeEnabled } = usePaymentsConfiguration();

  if (!isTrustedPayeeEnabled) {
    return null;
  }

  const isChecked = Boolean(getIn(values, getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.IS_TRUSTED_PAYEE)));

  return (
    <div className="rounded-md bg-teal-100 p-20">
      <PermissionsButtonWrapper action={PERMISSION_ACTIONS.TRUSTED_PAYEE_ARRANGEMENT} verb={PERMISSION_VERBS.WRITE}>
        <CheckboxFormik
          id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.IS_TRUSTED_PAYEE)}
          label={
            <Text variant="small" weight="medium">
              Trusted payee
            </Text>
          }
          disabled={disabled}
        />
      </PermissionsButtonWrapper>
      {isChecked ? (
        <div className="mt-16 grid grid-cols-2 gap-20">
          <PermissionsButtonWrapper action={PERMISSION_ACTIONS.TRUSTED_PAYEE_ARRANGEMENT} verb={PERMISSION_VERBS.WRITE}>
            <DatePickerTextFieldFormik
              id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.TRUSTED_PAYEE_VALID_TO)}
              label="Valid to"
              disablePast
              clearable
              disabled={disabled}
            />
          </PermissionsButtonWrapper>
          <PermissionsButtonWrapper action={PERMISSION_ACTIONS.TRUSTED_PAYEE_ARRANGEMENT} verb={PERMISSION_VERBS.WRITE}>
            <MonetaryValueTextFieldFormik
              id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.TRUSTED_PAYEE_PER_PAYMENT_LIMIT)}
              label="Per-payment limit"
              fullWidth
              disabled={disabled}
            />
          </PermissionsButtonWrapper>
        </div>
      ) : null}
    </div>
  );
};

export default TrustedPayee;
